import { render, staticRenderFns } from "./copyDraftsModal.vue?vue&type=template&id=4e2d0c58&scoped=true"
import script from "./copyDraftsModal.vue?vue&type=script&lang=js"
export * from "./copyDraftsModal.vue?vue&type=script&lang=js"
import style0 from "./copyDraftsModal.vue?vue&type=style&index=0&id=4e2d0c58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2d0c58",
  null
  
)

export default component.exports